import { FC, Fragment } from "react";
import { Stack } from "@mui/material";
import { K8SLiveUsageResourceGridCsvExport } from "./K8SLiveUsageResourceGridCsvExport";
import { KubernetesLiveUsageMgmtResourceCardStatistics } from "./KubernetesLiveUsageMgmtResourceCardStatistics";
import { KubernetesLiveUsageMgmtResourceCardFilterContent } from "./KubernetesLiveUsageMgmtResourceCardFilterContent";
import { AgGridGlobalSearch } from "../../../../common/ag-grid/components/global-search/AgGridGlobalSearch";
import { AGGridColumnsToolPanel } from "../../../../common/ag-grid/components/AGGridColumnsToolPanel";
import type { GridApi } from "ag-grid-community";
import { ResourceType } from "@/services/cloudchipr.api";
import { K8SLiveUsageResourceGridToolbarQuickActions } from "@/components/pages/kubernetes-live-usage-mgmt/components/resources-area/toolbar/K8SLiveUsageResourceGridToolbarQuickActions";
import { useAppSelector } from "@/store/hooks";
import { k8sLiveUsageResourceMetadataTotalResourcesCountSelector } from "@/store/kubernetes-live-usage-mgmt/selectors/resource-type-data/resource-metadata/count/k8sLiveUsageResourceMetadataTotalResourcesCountSelector";
import { LiveUsageResourceSingleHeader } from "@/components/pages/live-usage-mgmt/components/resources-area/LiveUsageResourceSingleHeader";

interface K8SLiveUsageResourceGridToolbarProps {
  masterResourceType: ResourceType;
  gridApi: GridApi | null;
  masterGridId: string;
}

export const K8SLiveUsageResourceGridToolbar: FC<
  K8SLiveUsageResourceGridToolbarProps
> = ({ masterResourceType, gridApi, masterGridId }) => {
  const resourcesTotalCount = useAppSelector((state) =>
    k8sLiveUsageResourceMetadataTotalResourcesCountSelector(
      state,
      masterResourceType,
    ),
  );

  return (
    <Fragment>
      <Stack p={1} spacing={1}>
        <LiveUsageResourceSingleHeader
          count={resourcesTotalCount}
          resourceType={masterResourceType}
        />
        <KubernetesLiveUsageMgmtResourceCardStatistics
          resourceType={masterResourceType}
        />
      </Stack>

      <Stack
        px={2}
        pb={1}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Stack direction="row" spacing={0.5}>
          <KubernetesLiveUsageMgmtResourceCardFilterContent
            resourceType={masterResourceType}
          />
        </Stack>

        <Stack alignItems="center" direction="row" spacing={1}>
          <K8SLiveUsageResourceGridToolbarQuickActions
            masterGridId={masterGridId}
          />

          <AgGridGlobalSearch gridApi={gridApi} />

          <K8SLiveUsageResourceGridCsvExport
            gridApi={gridApi}
            resourceType={masterResourceType}
          />

          <AGGridColumnsToolPanel gridApi={gridApi} />
        </Stack>
      </Stack>
    </Fragment>
  );
};
